<div class="quick-bar" *ngIf="hasMetadata">

  <div class="quick-bar-left">
    <span *ngIf="projectType"
          class="status-pill project-type-pill">
      {{ projectTypeLabel }}
      <app-info-tooltip *ngIf="projectTypeGlossaryTerm" [term]="$any(projectTypeGlossaryTerm)" [size]="11"></app-info-tooltip>
    </span>
  </div>

  <div class="quick-bar-center">
    <span *ngIf="hasTotal" class="total-block">
      <span class="total-label">TOTAL</span>
      <strong class="total-value">{{ totalWithContingency }}H</strong>
      <app-info-tooltip [text]="totalTooltip" [size]="12"></app-info-tooltip>
    </span>
  </div>

  <div class="quick-bar-right">
    <button *ngIf="warningCount > 0"
            class="btn secondary sm warnings-trigger"
            (click)="onWarningsClick()">
      <svg viewBox="0 0 24 24"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
      {{ warningCount }} {{ warningCount === 1 ? 'aviso' : 'avisos' }}
    </button>
  </div>

</div>
